<template>
    <h1>Payment Success</h1>
    <i class="bi bi-check-circle text-success display-1"></i>
    <p>Your payment has been processed successfully, you can now close this window and complete your order details. Thank you for your payment..</p>
</template>


